<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="header-title">Advanced Data Table</h4> -->
            <p class="text-muted font-13 mb-0"></p>
            <!-- Table -->
            <div>
              <good-table-column-search :moduleapi="`${this.baseApi}/voucher`" title="Voucher" :columns="columns"
                routerpath="/accounting/addvoucher" :formOptions="formOptions" :edit="edit" :add="add"
                :canDelete="canDelete">
                <template #action="{ row, getGridData }">
                  <div class="d-flex">
                    <!-- Approve/Reject buttons - visible to admin/users with approval access -->
                    <b-badge v-if="
                      (isAdmin || approvalAccess) &&
                      (row.approved1 == 'Pending' || row.approved1 == 'Rejected' || !row.approved1 || row.approved1 == null)
                    " variant="primary" :id="'voucherApprove' + row.id" class="mr-50 cursor-pointer"
                      @click="approveVoucher(row, 'Approved', getGridData)">
                      <b-spinner v-if="row.loading" small variant="light" />
                      <feather-icon v-else icon="CheckIcon" />
                    </b-badge>
                    <b-tooltip v-if="
                      (isAdmin || approvalAccess) &&
                      (row.approved1 == 'Pending' || row.approved1 == 'Rejected' || !row.approved1 || row.approved1 == null)
                    " :target="'voucherApprove' + row.id" triggers="hover">
                      Approve
                    </b-tooltip>

                    <b-badge v-if="(isAdmin || approvalAccess) && row.approved1 != 'Rejected' && row.approved1 != 'Approved'" variant="danger"
                      :id="'voucherReject' + row.id" class="mr-50 cursor-pointer"
                      @click="approveVoucher(row, 'Rejected', getGridData)">
                      <b-spinner v-if="row.loading" small variant="light" />
                      <feather-icon v-else icon="XIcon" />
                    </b-badge>

                    <b-tooltip v-if="(isAdmin || approvalAccess) && row.approved1 != 'Rejected' && row.approved1 != 'Approved'" :target="'voucherReject' + row.id"
                      triggers="hover">
                      Reject
                    </b-tooltip>

                    <!-- Print button - visible to all users (admin and logged in users) only when canPrint is true -->
                    <b-badge v-if="row.canPrint === true || row.canPrint === 'true' || (row.approved1 == 'Approved' || row.approved2 == 'Approved')" 
                      :id="'print' + row.id" 
                      @click="handleVoucherPrint(row)" variant="success" class="mr-50 cursor-pointer">
                      <b-spinner v-if="row.printing" small variant="light" />
                      <feather-icon v-else icon="PrinterIcon" />
                    </b-badge>
                    <b-tooltip v-if="row.canPrint === true || row.canPrint === 'true' || (row.approved1 == 'Approved' || row.approved2 == 'Approved')" 
                      :id="'print' + row.id" 
                      :target="'print' + row.id" triggers="hover">
                      Print Voucher
                    </b-tooltip>
                  </div>
                </template>
              </good-table-column-search>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="true" :preview-modal="false"
      :paginate-elements-by-height="1400" filename="Voucher" :html2canvas="{}" :jsPDF="{
        format: 'a4',
      }" :pdf-quality="3" :manual-pagination="false" pdf-format="a4" :pdf-margin="0" pdf-orientation="portrait"
      pdf-content-width="800px" ref="html2Pdf">
      <section slot="pdf-content">
        <print-voucher :voucherData="voucherData" />
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import axios from '@/components/axios';
import GoodTableColumnSearch from "../../../components/GoodTableColumnSearch.vue";
import printVoucher from "@/views/print/printVoucher.vue";
import VueHtml2pdf from "vue-html2pdf";
import { BBadge, BTooltip, BSpinner } from "bootstrap-vue";
import moment from "moment";
const baseApi = process.env.VUE_APP_APIENDPOINT;

export default {
  components: {
    GoodTableColumnSearch,
    printVoucher,
    VueHtml2pdf,
    BBadge,
    BTooltip,
    BSpinner,
  },
  data() {
    return {
      baseApi: process.env.VUE_APP_APIENDPOINT,
      formOptions: {
        formTitle: `${this.$route.params.id ? "Edit ChequeReturn" : "Add ChequeReturn"
          }`,
        submitRouterPath: "/crm/chequereturn",
        usersDropdown: true,
        method: "post",
        action: "add",
        url: `${baseApi}/chequereturn`,
        inputFields: [
          {
            name: "branch",
            value: 1,
            type: "hidden",
          },
          {
            name: "company",
            value: 1,
            type: "hidden",
          },
          // {
          //   name: "nextfollowupdate",
          //   value: `${moment(new Date()).format("DD/MM/yyyy")}`,
          //   type: "hidden",
          // },
          {
            name: "active",
            value: 1,
            type: "hidden",
          },
          {
            label: "Voucher NO",
            name: "voucherno",
            value: "",
            type: "number",
            placeholder: "Enter Voucher Number",
            class: "col-md-6",
            // required: {
            //   required,
            // },
          },
          {
            label: "Date",
            name: "date",
            value: moment(new Date()).format("yyyy-MM-DD"),
            type: "date",
            placeholder: "Select date",
            class: "col-md-6",
            // required: {
            //   required,
            // },
          },
          {
            label: "Cheque NO",
            name: "chequeno",
            value: "",
            type: "number",
            placeholder: "Enter Cheque Number",
            class: "col-md-6",
            // required: {
            //   required,
            // },
          },
          {
            label: "Client Name",
            name: "clientname",
            value: "",
            type: "text",
            placeholder: "Enter Client Name",
            class: "col-md-6",
            // required: {
            //   required,
            // },
          },
          {
            label: "Company Name",
            name: "companyname",
            value: "",
            type: "dropdown",
            class: "col-md-6",
            dropdownname: "companyname",
            options: [],
            // required: {
            //   required,
            // },
          },
          {
            label: "Bank Name",
            name: "bankname",
            value: "",
            type: "text",
            placeholder: "Enter Bank Name",
            class: "col-md-6",
            // required: {
            //   required,
            // },
          },
          {
            label: "Amount",
            name: "amount",
            value: "",
            type: "text",
            placeholder: "Enter Amount",
            class: "col-md-6",
            // required: {
            //   required,
            // },
          },
          {
            label: "Cheque Date",
            name: "chequedate",
            value: moment(new Date()).format("yyyy-MM-DD"),
            type: "date",
            placeholder: "Select Cheque date",
            class: "col-md-6",
            // required: {
            //   required,
            // },
          },
          {
            label: "Reason",
            name: "reason",
            value: "",
            type: "text",
            placeholder: "Enter Reason",
            class: "col-md-6",
            // required: {
            //   required,
            // },
          },
          {
            label: "Client's Bank",
            name: "clientbank",
            value: "",
            type: "text",
            placeholder: "Enter Client's Bank",
            class: "col-md-6",
          },
        ],
      },
      columns: [
        {
          label: "Date",
          field: "date",
          type: 'datetime',
          filterOptions: {
            enabled: true,
            placeholder: "Search Date",
          },
        },
        {
          label: "Branch",
          field: "branch",
          type: "dropdown",
          url: "branch",
          responseValue: "name",
          filterOptions: {
            enabled: true,
            placeholder: "Search Branch",
          },
        },
        {
          label: "Narration",
          field: "narration",
          filterOptions: {
            enabled: true,
            placeholder: "Search Narration",
          },
        },
        {
          label: "Type",
          field: "type",
          filterOptions: {
            enabled: true,
            placeholder: "Search Type",
          },
        },
        {
          label: "Status",
          field: "approved1",
          filterOptions: {
            enabled: true,
            placeholder: "Search Status",
          },
        },
        {
          label: "Enter By",
          field: "enterby",
          type: "staticdropdown",
          responseValue: 'fullname',
          url: 'getUsers',
          filterOptions: {
            enabled: true,
            placeholder: "Search Name",
          },
        },
        {
          label: "Enter Date",
          field: "enterdatetime",
          type: "datetime",
          time: true,
          filterOptions: {
            enabled: true,
            placeholder: "Search Date",
          },
        },
        {
          label: "Modified By",
          field: "modifiedby",
          type: "staticdropdown",
          responseValue: 'fullname',
          url: 'getUsers',
          filterOptions: {
            enabled: true,
            placeholder: "Search Name",
          },
        },
        {
          label: "Modified Date",
          field: "modifieddatetime",
          time: true,
          type: "datetime",
          filterOptions: {
            enabled: true,
            placeholder: "Search Date",
          },
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      edit: "",
      add: "",
      canDelete: "",
      voucherData: null,
      accessToken: localStorage.getItem("accessToken"),
      approvalAccess: false,
      isAdmin: false,
    };
  },

  mounted() {
    const userData = JSON.parse(localStorage.getItem("UserRights"));
    const userInfo = JSON.parse(localStorage.getItem("userData"));
    const role = userInfo ? userInfo.role : "";
    this.isAdmin = role === "admin";
    
    if (role !== "admin") {
      userData.map((item) => {
        if (item.modulename == "Voucher") {
          this.edit = item.edit;
          this.add = item.add;
          this.canDelete = item.delete;

          if (
            item.edit !== 1 &&
            item.add !== 1 &&
            item.delete !== 1 &&
            item.view !== 1
          ) {
            this.$router.push("/");
          }
        }
      });
    }
  },
  watch: {
    "$store.state.app.user_approval": {
      handler: "getAccess",
      immediate: true,
    },
  },
  methods: {
    getAccess() {
      this.approvalAccess = this.$store.getters["app/approvalAccess"]("Voucher");
    },
    async handleVoucherPrint(row) {
      if (row.printing) {
        return;
      }
      this.$set(row, 'printing', true);
      this.$forceUpdate();
      
      try {
        const requestOptions = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
            Accept: "application/json",
          },
          url: `${this.baseApi}/voucher/generate-pdf/${row.id}`,
        };

        const response = await axios(requestOptions);
        
        if (response.data.status === 200 && response.data.data) {
          this.voucherData = response.data.data;
          this.$refs.html2Pdf.generatePdf();
        } else {
          this.$swal({
            title: "Error",
            text: response.data.message || "Failed to fetch voucher data",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        }
      } catch (error) {
        console.error("Error fetching voucher print data:", error);
        this.$swal({
          title: "Error",
          text: error.response?.data?.message || "Failed to load voucher data for printing",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      } finally {
        this.$set(row, 'printing', false);
        this.$forceUpdate();
      }
    },
    async approveVoucher(row, status, getGridData) {
      !row.loading &&
        this.$swal({
          title: `Are you sure to ${status == "Approved" ? "Approve" : "Reject"}?`,
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `${status == "Approved" ? "Approve" : "Reject"}`,
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        })
          .then(async (result) => {
            const data = {
              approved1: status,
            };
            row.loading = true;

            if (status == "Approved") {
              data.approved1datetime = moment(new Date()).format();
            }
            if (result.value) {
              await axios({
                method: "put",
                url: `${this.baseApi}/voucher/${row.id}`,
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${this.accessToken}`,
                },
                data: JSON.stringify(data),
              })
                .then((json) => {
                  if (json.data.status == 200 || json.data) {
                    this.$swal({
                      icon: "success",
                      title: `${status == "Approved" ? "Approved" : "Rejected"}`,
                      text: `Your data has been ${status == "Approved" ? "Approved" : "Rejected"
                        }.`,
                      customClass: {
                        confirmButton: "btn btn-success",
                      },
                    });
                    getGridData();
                  }
                })
                .catch((error) =>
                  this.$swal({
                    title: "Error!",
                    text: `${error.response?.data?.message}`,
                    icon: "error",
                    timer: 5000,
                    customClass: {
                      confirmButton: "btn btn-primary",
                    },
                    buttonsStyling: false,
                  })
                )
                .finally(() => {
                  row.loading = false;
                  this.$forceUpdate();
                });
            }
          })
          .catch((error) => console.log(error, "error"));
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
